Du: vue
<template>
  <div class="dashboard">
    <!-- Sidebar -->
    <div class="sidebar">
      <sidebarComponent />
    </div>
    <!-- Main Content -->
    <div class="main-content">
      <WaitingDriversNumber :waiting-captains="waitingCaptains" />
      <div class="transaction-management">
        <h2 class="section-title">Transaction Management</h2>

        <!-- Display Wallet -->
        <p class="wallet-info">Driver Wallet: {{ wallet || "N/A" }}</p>
        <!-- +++ DETAILS CARD (يظهر فقط لو الطلب Pending) +++ -->
        <div
          v-if="requestMeta && requestMeta.status"
          class="details-card"
          style="
            margin: 10px 0 20px;
            border: 1px solid #eee;
            border-radius: 10px;
            padding: 16px;
          "
        >
          <div
            style="
              display: flex;
              align-items: center;
              gap: 10px;
              margin-bottom: 10px;
            "
          >
            <img
              v-if="requestMeta.profileImage"
              :src="requestMeta.profileImage"
              alt="avatar"
              style="
                width: 40px;
                height: 40px;
                border-radius: 50%;
                object-fit: cover;
                border: 1px solid #eee;
              "
            />
            <div>
              <div><b>Captain:</b> {{ requestMeta.driverName || "-" }}</div>
              <div><b>Phone:</b> {{ requestMeta.phone || "-" }}</div>
            </div>
          </div>

          <div
            style="
              display: grid;
              grid-template-columns: repeat(2, minmax(0, 1fr));
              gap: 8px;
            "
          >
            <div><b>Request ID:</b> {{ requestId }}</div>
            <div><b>Status:</b> {{ requestMeta.status }}</div>

            <div>
              <b>Amount:</b>
              {{ (transaction.amount || 0).toLocaleString("en-EG") }} EGP
            </div>
            <div v-if="requestMeta.type">
              <b>Type:</b> {{ requestMeta.type }}
            </div>

            <div v-if="requestMeta.account">
              <b>Account:</b> {{ requestMeta.account }}
            </div>
            <div v-if="requestMeta.holderName">
              <b>Holder Name:</b> {{ requestMeta.holderName }}
            </div>

            <div v-if="requestMeta.walletBefore || requestMeta.walletAfter">
              <b>Wallet Before → After:</b>
              {{ requestMeta.walletBefore || "—" }} →
              {{ requestMeta.walletAfter || "—" }}
            </div>
            <div v-if="requestMeta.createdAt">
              <b>Created:</b> {{ requestMeta.createdAt }}
            </div>
            <div v-if="requestMeta.updatedAt">
              <b>Updated:</b> {{ requestMeta.updatedAt }}
            </div>

            <div
              v-if="!isPending && (requestMeta.filledBy || transaction.sender)"
            >
              <b>Filled by:</b> {{ requestMeta.filledBy || transaction.sender }}
            </div>

            <!-- 👇 دول هيتعرضوا لما الطلب Approved (بدّلي isApproved بـ !isPending لو عايزاهم يظهروا في Rejected كمان) -->
            <div v-if="isApproved && requestMeta.adminName">
              <b>Admin:</b> {{ requestMeta.adminName }}
            </div>
          </div>

          <div
            v-if="
              isApproved && (requestMeta.transfareId || requestMeta.transferId)
            "
          >
            <b>Transfer ID:</b>
            {{ requestMeta.transfareId || requestMeta.transferId }}
          </div>
          <div
            v-if="
              isApproved &&
              (requestMeta.transfareMethod || requestMeta.transferMethod)
            "
          >
            <b>Transfer Method:</b>
            {{ requestMeta.transfareMethod || requestMeta.transferMethod }}
          </div>
        </div>

        <!-- Transaction Form -->
        <div v-if="isPending" class="transaction-form">
          <div class="input-wrapper">
            <input
              v-model="idDriver"
              placeholder="Enter ID Driver"
              class="form-input"
            />
          </div>

          <!-- Transfer Method Dropdown -->
          <div class="input-wrapper">
            <select
              v-model="selectedTransferMethod"
              @change="updateTransferBy"
              class="form-input"
            >
              <option value="">Transfer by</option>
              <option value="wallet">Wallet</option>
              <option value="enstapay">ENSTAPAY</option>
            </select>
          </div>

          <!-- Wallet Options -->
          <div class="input-wrapper" v-if="selectedTransferMethod === 'wallet'">
            <select
              v-model="transaction.transferBy"
              class="form-input"
              v-if="selectedTransferMethod === 'wallet'"
              :key="'wallet'"
            >
              <option disabled value="">Choose Wallet Network</option>
              <option value="Vodafone">Vodafone</option>
              <option value="Etisalat">Etisalat</option>
              <option value="WE">WE</option>
              <option value="Orange">Orange</option>
            </select>
          </div>

          <!-- ENSTAPAY Options -->
          <div
            class="input-wrapper"
            v-if="selectedTransferMethod === 'enstapay'"
          >
            <select
              v-model="transaction.transferBy"
              class="form-input"
              v-if="selectedTransferMethod === 'enstapay'"
              :key="'enstapay'"
            >
              <option disabled value="">Choose ENSTAPAY Method</option>
              <option value="Email">Email</option>
              <option value="Card">Card</option>
              <option value="Phone Number">Phone Number</option>
            </select>
          </div>

          <div class="input-wrapper">
            <input
              v-model="sender"
              placeholder="Sender Name"
              class="form-input transfer-by"
              :disabled="true"
            />
          </div>
          <div class="input-wrapper">
            <input
              v-model.number="transaction.amount"
              placeholder="Enter an Amount"
              class="form-input transfer-by"
              type="number"
            />
          </div>
          <div class="input-wrapper">
            <input
              v-model="transaction.transactionNumber"
              placeholder="Enter Transaction Number"
              class="form-input"
            />
          </div>
          <div
            class="actions"
            style="
              display: flex;
              gap: 10px;
              align-items: center;
              margin-top: 8px;
            "
          >
            <button
              type="button"
              class="confirm-button"
              @click.stop.prevent="applyTransfer"
              :disabled="!isPending || submitting || !canSubmit"
            >
              {{ submitting ? "Processing..." : "Confirm" }}
            </button>

            <button
              type="button"
              class="reject-button"
              @click="openReject"
              :disabled="submitting"
            >
              Reject
            </button>

            <!-- سِيبى زرار النسخ زي ما هو -->
          </div>

          <button @click="copyAllText" class="copy-button">📋</button>
          <p v-if="transaction.updatedAt" class="timestamp">
            Transfer Time: {{ formatDate(transaction.updatedAt) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import sidebarComponent from "@/components/sidebarComponent.vue";
import WaitingDriversNumber from "@/components/waitingDriversNumber.vue";
import axios from "@/axios";

export default defineComponent({
  components: { WaitingDriversNumber, sidebarComponent },
  data() {
    return {
      waitingCaptains: 0, // Added to avoid prop error
      wallet: this.$route.query.wallet || "N/A",
      requestId:
        this.$route.query.requestId ||
        this.$route.params.id ||
        this.$route.params.requestId ||
        this.$route.params.reqId ||
        "",
      selectedTransferMethod: "",
      transaction: {
        idDriver: this.$route.params.id || "",
        transferBy: "",

        sender: "",
        amount: parseFloat(this.$route.query.amount) || 0,
        transactionNumber: "",
        updatedAt: null,
      },

      submitting: false,
      isUnmounted: false,
      navigationDone: false,
      requestMeta: {
        status: this.$route.query.status || "",
        type: this.$route.query.type || "",
        account: this.$route.query.account || "",
        holderName: this.$route.query.holderName || "",
        createdAt: this.$route.query.createdAt || "",
        updatedAt: this.$route.query.updatedAt || "",
        walletBefore: this.$route.query.walletBefore || "",
        walletAfter: this.$route.query.walletAfter || "",
        driverName: this.$route.query.driverName || "",
        phone: this.$route.query.phone || "",
        profileImage:
          this.$route.query.profileImage ||
          this.$route.query.profile_image ||
          "",
        filledBy: this.$route.query.filledBy || "",
        adminName: this.$route.query.adminName || "",
        transfareId:
          this.$route.query.transfareId || this.$route.query.transferId || "",
        transfareMethod:
          this.$route.query.transfareMethod ||
          this.$route.query.transferMethod ||
          "",
      },
    };
  },
  computed: {
    sender: {
      get() {
        return this.transaction.sender;
      },
      set(value) {
        this.transaction.sender = value;
      },
    },
    idDriver: {
      get() {
        return this.transaction.idDriver;
      },
      set(value) {
        this.transaction.idDriver = value;
      },
    },
    isPending() {
      return String(this.requestMeta.status || "").toLowerCase() === "pending";
    },
    isApproved() {
      return String(this.requestMeta.status || "").toLowerCase() === "approved";
    },
    // تحقق سريع إن الحقول الأساسية موجودة
    canSubmit() {
      return (
        !!this.transaction.idDriver &&
        !!this.requestId &&
        Number(this.transaction.amount) > 0 &&
        !!this.selectedTransferMethod &&
        !!this.transaction.transactionNumber
      );
    },
  },
  created() {
    this.idDriver = this.$route.params.id || "";
    this.sender = localStorage.getItem("username") || "Unknown";
    this.hydrateFromQuery();
    if (!this.requestId) {
      this.requestId =
        this.$route.query.requestId ||
        this.$route.params.id ||
        this.$route.params.requestId ||
        this.$route.params.reqId ||
        this.requestId ||
        "";
    }
    this.fetchRequestMeta(); // بدل البلوك القديم كله
  },
  mounted() {
    // لو حابب تضمن النداء بعد التركيب
    if (!this.requestMeta.adminName && this.requestId) this.fetchRequestMeta();
  },

  beforeUnmount() {
    this.isUnmounted = true;
  },

  methods: {
    makeIdemKey() {
      const raw = `${this.requestId}::${
        this.transaction.transactionNumber || ""
      }`;
      try {
        // UTF-8 → Base64 (ASCII آمن للهيدر)
        return btoa(unescape(encodeURIComponent(raw))).slice(0, 128);
      } catch (e) {
        return `${this.requestId}-${Date.now()}`; // fallback
      }
    },
    getAdminName() {
      return (
        localStorage.getItem("username") || this.transaction.sender || "Unknown"
      );
    },
    beforeRouteLeave(to, from, next) {
      // امنعي أي محاولة انتقال لصفحة success
      const isSuccessRoute =
        (to.name && String(to.name).toLowerCase().includes("success")) ||
        (to.path && to.path.toLowerCase().includes("success"));

      if (isSuccessRoute) {
        console.log("Blocked navigation to success page");
        return next(false); // إلغاء التنقل
      }
      next(); // اسمحي بأي Route تانية (زي /get-req)
    },

    async fetchRequestMeta() {
      if (!this.requestId) return;
      try {
        const tryFind = async (extraParams = {}) => {
          let page = 1,
            found = null;
          while (!found && page <= 50) {
            const { data } = await axios.get("/getReq", {
              params: { page, ...extraParams },
              timeout: 10000,
            });
            const root =
              data?.requests ?? data?.request ?? data?.data ?? data?.docs ?? [];
            const list = Array.isArray(root)
              ? root
              : Array.isArray(root.requests)
              ? root.requests
              : [];
            if (!Array.isArray(list) || list.length === 0) break;
            found = list.find((x) => x?._id === this.requestId);
            page++;
          }
          return found;
        };

        // 1) دور في التاب الحالي (لو متوفر)
        const preferredStatus =
          this.$route.query.fromStatus ||
          this.$route.query.status ||
          this.requestMeta.status;

        let found = await tryFind(
          preferredStatus ? { status: preferredStatus } : {}
        );

        // 2) لو ملقاهوش، جرّب من غير فلتر حالة
        if (!found) found = await tryFind();

        if (!found) return;

        this.requestMeta = {
          ...this.requestMeta,
          status: found.status ?? this.requestMeta.status,
          type: found.type ?? this.requestMeta.type,
          account: found.account ?? this.requestMeta.account,
          holderName: found.holderName ?? this.requestMeta.holderName,
          createdAt: found.createdAt ?? this.requestMeta.createdAt,
          updatedAt: found.updatedAt ?? this.requestMeta.updatedAt,
          walletBefore: found.walletBefore ?? this.requestMeta.walletBefore,
          walletAfter: found.walletAfter ?? this.requestMeta.walletAfter,
          driverName: found.driverId?.username ?? this.requestMeta.driverName,
          phone: found.driverId?.phoneNumber ?? this.requestMeta.phone,
          profileImage:
            found.driverId?.profile_image ?? this.requestMeta.profileImage,
          adminName: found.adminName ?? this.requestMeta.adminName,
          transfareId:
            found.transfareId ??
            found.transferId ??
            this.requestMeta.transfareId,
          transfareMethod:
            found.transfareMethod ??
            found.transferMethod ??
            this.requestMeta.transfareMethod,
          filledBy: found.filledBy ?? this.requestMeta.filledBy,
        };
      } catch (e) {
        console.warn(e);
      }
    },

    updateTransferBy() {
      this.transaction.transferBy = ""; // Reset عند التغيير
    },
    async applyTransfer() {
      if (this.submitting) return;

      // Checks
      if (!this.isPending) {
        alert("Request is not pending.");
        return;
      }
      if (!this.requestId) {
        alert("Missing requestId");
        return;
      }
      if (
        !this.transaction.idDriver ||
        !(Number(this.transaction.amount) > 0)
      ) {
        alert("Please fill driver ID and a valid amount.");
        return;
      }
      if (!this.selectedTransferMethod) {
        alert("Choose transfer method (wallet or enstapay).");
        return;
      }
      if (!this.transaction.transactionNumber) {
        alert("Enter Transaction Number (Transfer ID).");
        return;
      }

      this.submitting = true;
      let navigate = false;

      try {
        const headers = { "Idempotency-Key": this.makeIdemKey() };

        // ✅ موافقة مباشرة بدون /applyReq
        const adminName =
          localStorage.getItem("username") ||
          this.transaction.sender ||
          "Unknown";

        const payload = {
          requestId: this.requestId,
          adminName, // اسم الأدمن
          transfareMethod: this.selectedTransferMethod, // wallet | enstapay
          transferMethod: this.selectedTransferMethod, // احتياطي لو السيرفر بيقرأ ده
          transfareId: this.transaction.transactionNumber, // Transaction Number
          transferId: this.transaction.transactionNumber, // احتياطي
          // لو السيرفر محتاج amount/idDriver برضه:
          // amount: this.transaction.amount,
          // driverId: this.transaction.idDriver,
        };

        const resp = await axios.post("/approveReq", payload, {
          timeout: 15000,
          headers,
        });

        // حدّثي الـ UI
        const a = resp?.data?.request || resp?.data || {};
        this.transaction.updatedAt = new Date();
        this.requestMeta = {
          ...this.requestMeta,
          status: "approved",
          adminName: a.adminName ?? adminName,
          transfareId:
            a.transfareId ?? a.transferId ?? this.transaction.transactionNumber,
          transfareMethod:
            a.transfareMethod ??
            a.transferMethod ??
            this.selectedTransferMethod,
          filledBy: this.requestMeta.filledBy || this.transaction.sender,
          updatedAt: a.updatedAt ?? this.requestMeta.updatedAt,
        };

        // تنقّل واحد بس لقائمة Approved
        navigate = true;
      } catch (error) {
        alert(
          error?.response?.data?.message || error.message || "Failed to approve"
        );
      } finally {
        this.submitting = false;
        if (!this.navigationDone && navigate) this.safeGoBack("approved");
      }
    },

    hydrateFromQuery() {
      const q = this.$route.query || {};

      // قيَم بسيطة
      if (typeof q.wallet !== "undefined") this.wallet = q.wallet;
      if (typeof q.requestId !== "undefined") this.requestId = q.requestId;

      // amount لو جاي في الquery
      if (q.amount != null) {
        const n = Number(q.amount);
        if (!Number.isNaN(n)) this.transaction.amount = n;
      }

      // حدّث الميتاداتا
      this.requestMeta = {
        ...this.requestMeta,
        status: q.status ?? this.requestMeta.status,
        type: q.type ?? this.requestMeta.type,
        account: q.account ?? this.requestMeta.account,
        holderName: q.holderName ?? this.requestMeta.holderName,
        createdAt: q.createdAt ?? this.requestMeta.createdAt,
        updatedAt: q.updatedAt ?? this.requestMeta.updatedAt,
        walletBefore: q.walletBefore ?? this.requestMeta.walletBefore,
        walletAfter: q.walletAfter ?? this.requestMeta.walletAfter,
        driverName: q.driverName ?? this.requestMeta.driverName,
        phone: q.phone ?? this.requestMeta.phone,
        profileImage:
          q.profileImage || q.profile_image || this.requestMeta.profileImage,
        adminName: q.adminName ?? this.requestMeta.adminName,
        transfareId:
          q.transfareId ?? q.transferId ?? this.requestMeta.transfareId,
        transfareMethod:
          q.transfareMethod ??
          q.transferMethod ??
          this.requestMeta.transfareMethod,
      };
    },
    goBackToList(statusOverride = "approved") {
      const page = Number(this.$route.query.fromPage) || 1;
      const status =
        statusOverride || this.$route.query.fromStatus || "approved";
      this.$router.replace({ path: "/get-req", query: { page, status } });
    },
    safeGoBack(statusOverride = "approved") {
      if (this.navigationDone) return; // امنعي التكرار
      this.navigationDone = true;

      const page = Number(this.$route.query.fromPage) || 1;
      const status =
        statusOverride || this.$route.query.fromStatus || "approved";
      this.$router.replace({ path: "/get-req", query: { page, status } });
    },

    formatDate(date) {
      if (!date) return "";
      return date
        .toLocaleString("en-GB", {
          day: "numeric",
          month: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "numeric",
          second: "numeric",
          hour12: false,
        })
        .replace(",", "");
    },
    async approveReq() {
      // ✅ برضه اتأكدي من الـ requestId
      if (!this.requestId) {
        alert("Missing requestId");
        return;
      }
      console.log("approveReq -> requestId:", this.requestId);

      try {
        const { data } = await axios.post(
          "/approveReq",
          { requestId: this.requestId },
          { timeout: 10000 }
        );
        alert("Request approved successfully");
        const a = data?.request || data?.data || data || {};
        this.requestMeta.status = "approved";
        this.requestMeta.adminName = a.adminName ?? this.requestMeta.adminName;
        this.requestMeta.transfareId =
          a.transfareId ?? a.transferId ?? this.requestMeta.transfareId;
        this.requestMeta.transfareMethod =
          a.transfareMethod ??
          a.transferMethod ??
          this.requestMeta.transfareMethod;
        if (!this.requestMeta.filledBy)
          this.requestMeta.filledBy = this.transaction.sender;
      } catch (e) {
        alert(e?.response?.data?.message || e.message || "Failed to approve");
      }
    },

    openReject() {
      const reason = prompt("Reject reason:");
      if (!reason) return;
      this.rejectReq(reason);
    },

    async rejectReq(reason) {
      try {
        await axios.post(
          "/rejectReq",
          { requestId: this.requestId, rejectReason: reason },
          { timeout: 10000 }
        );
        alert("Request rejected successfully");
        this.requestMeta.status = "rejected";
        // ✅ ارجعي للريكوستات – تاب Rejected
        this.goBackToList("rejected");
      } catch (e) {
        alert(e?.response?.data?.message || e.message || "Failed to reject");
        // (اختياري) ممكن تسيبي الرجوع هنا كمان لو حابة ترجعي حتى لو فشل
        // this.goBackToList("rejected");
      }
    },

    copyAllText() {
      const allText = `${this.transaction.idDriver}\n${this.transaction.sender}\n${this.transaction.transferBy}\n${this.transaction.amount}\n${this.transaction.transactionNumber}\nWallet: ${this.wallet}`;
      if (allText.trim()) {
        navigator.clipboard
          .writeText(allText)
          .then(() => {
            alert("All text copied to clipboard!");
          })
          .catch((err) => {
            console.error("Failed to copy text: ", err);
            alert("Failed to copy text");
          });
      }
    },
  },
});
</script>

<style scoped>
.dashboard {
  display: flex;
  min-height: 100vh;
}

.sidebar {
  width: 250px;
  background-color: #2f1c6a;
  color: white;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.main-content {
  margin-left: 250px;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f5f7fa;
  padding: 20px;
}

.transaction-management {
  padding: 20px;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  width: 100%;
  max-width: 900px;
}

.section-title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
  color: #34495e;
}

.wallet-info {
  font-size: 18px;
  color: #2c3e50;
  margin-bottom: 15px;
  text-align: center;
}

.transaction-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.input-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  justify-content: center;
}

.form-input {
  width: 100%;
  max-width: 400px;
  padding: 15px;
  border: 1px solid #ccc;
  border-radius: 25px;
  font-size: 16px;
  background-color: #f5f5ff;
}

.form-input:disabled {
  background-color: #e0e0e0;
  cursor: not-allowed;
}

.transfer-by {
  width: 792px;
  height: 73px;
}

.copy-button {
  background: none;
  border: none;
  font-size: 20px;
  cursor: pointer;
  padding: 5px;
  margin-top: 10px;
}

.copy-button:hover {
  opacity: 0.7;
}

.confirm-button {
  background-color: #6b48ff;
  color: white;
  padding: 10px 40px;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  cursor: pointer;
}

.confirm-button:hover {
  background-color: #563bd1;
}

.timestamp {
  font-size: 14px;
  color: #666;
  margin-top: 10px;
  text-align: center;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .sidebar {
    width: 80px;
  }
  .main-content {
    margin-left: 80px;
  }
  .form-input.transfer-by {
    width: 100%;
    height: 50px;
  }
}

.wallet-info {
  font-weight: bold;
  color: #6b5b95;
  font-size: 1.2em;
}
.reject-button {
  background-color: #e74c3c;
  color: #fff;
  padding: 10px 24px;
  border: none;
  border-radius: 10px;
  font-size: 16px;
  cursor: pointer;
}
.reject-button:hover {
  background-color: #c0392b;
}
</style>
